import { render } from "./selectMenuTreeSingle.vue?vue&type=template&id=49f4e600"
import script from "./selectMenuTreeSingle.vue?vue&type=script&lang=js"
export * from "./selectMenuTreeSingle.vue?vue&type=script&lang=js"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__